import { Button } from '../../components/ui/button';
import { Grid3X3, List, Table2, LayoutGrid, FileSearch } from 'lucide-react';

export default function ViewTypeSwitcher({ viewType, setViewType }) {
  const viewTypes = [
    { key: 'icons', icon: Grid3X3, title: 'Icons View' },
    { key: 'list', icon: List, title: 'List View' },
    { key: 'details', icon: Table2, title: 'Details View' },
    { key: 'tiles', icon: LayoutGrid, title: 'Tiles View' },
    { key: 'content', icon: FileSearch, title: 'Content View' },
  ];

  return (
    <div className="flex items-center gap-1 border border-slate-200 rounded-lg p-1 bg-slate-50">
      {viewTypes.map(({ key, icon: Icon, title }) => (
        <Button
          key={key}
          variant="ghost"
          size="sm"
          onClick={() => setViewType(key)}
          className={`h-7 w-7 p-0 ${viewType === key ? 'bg-blue-100 text-blue-600' : 'text-slate-500 hover:text-slate-700'}`}
          title={title}
        >
          <Icon className="w-4 h-4" />
        </Button>
      ))}
    </div>
  );
}
